// reducers/apiReducer.js
const initialState = {
    loading: false,
    data: null,
    error: null,
  };
  
  const apiReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'DATA_FILE_REQUEST':
        return { ...state, loading: true, error: null };
      case 'DATA_FILE_SUCCESS':
        return { ...state, loading: false, data: action.payload };
      case 'DATA_FILE_FAILURE':
        return { ...state, loading: false, error: action.error };
      default:
        return state;
    }
  };
  
  export default apiReducer;
  